import { Outlet } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
  return (
    <>
      <Header />
      <main className="page">
        <Outlet />
      </main>
      <footer className="site-footer">
        <span>© {new Date().getFullYear()} Iván Olivera</span>
      </footer>
    </>
  );
}
